import React, { useState, useEffect } from 'react';

function App() {
  const [quotes, setQuotes] = useState([]);
  const [quote, setQuote] = useState('');

  // Fetch quotes from the backend API
  const fetchQuotes = () => {
    console.log('API URL:', process.env.REACT_APP_API_URL); // Add this line
    fetch(`${process.env.REACT_APP_API_URL}/quotes/`)
    .then(response => response.json())
      .then(data => {
        setQuotes(data.quotes);
        setRandomQuote(data.quotes);
      })
      .catch(error => console.error('Error:', error));
  };

  // Set a random quote
  const setRandomQuote = (quotesArray) => {
    const randomIndex = Math.floor(Math.random() * quotesArray.length);
    setQuote(quotesArray[randomIndex]);
  };

  useEffect(() => {
    fetchQuotes();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getNewQuote = () => {
    setRandomQuote(quotes);
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Welcome to TrustAudit AI</h1>
      <p style={{ fontStyle: 'italic' }}>{quote}</p>
      <button onClick={getNewQuote} disabled={quotes.length === 0}>
        Get a New Quote
      </button>
    </div>
  );
}

export default App;